import hash from 'hash.js';
import DataCenter from '../modules/DataCenter';

export async function get(url, headers) {
    const options = {
        headers: headers,
        method: "GET"
    }
    const resp = await fetch(url, options);
    if (resp.status == 200) {
        const json = await resp.json();
        return json;
    }
}

export function post(url, body) {
    return request(url, { method: "POST", body: body })
}

export function request(url, options) {

    const fingerprint = url + ((options && options.body) ? JSON.stringify(options.body) : '');
    const hashcode = hash
        .sha256()
        .update(fingerprint)
        .digest('hex');

    const defaultOptions = {
        credentials: 'include',
        mode: "cors",
    };
    const newOptions = { ...defaultOptions, ...options };

    newOptions.headers = {
        accountId: DataCenter.accountId,
        loginKey: DataCenter.loginKey,
        serviceId: DataCenter.serviceId(),
        channel: DataCenter.channel,
        ...newOptions.headers
    }

    if (newOptions.method === 'POST') {
        if (!(newOptions.body instanceof FormData)) {
            newOptions.headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                ...newOptions.headers,
            };
            newOptions.body = JSON.stringify(newOptions.body);
        } else {
            // newOptions.body is FormData
            newOptions.headers = {
                Accept: 'application/json',
                ...newOptions.headers,
            };
        }
    }

    const expirys = 60;
    // options.expirys !== false, return the cache,
    const cached = sessionStorage.getItem(hashcode);
    const whenCached = sessionStorage.getItem(`${hashcode}:timestamp`);
    if (cached !== null && whenCached !== null) {
        const age = (Date.now() - whenCached) / 1000;
        if (age < expirys) {
            const response = new Response(new Blob([cached]));
            return response.json();
        }
        sessionStorage.removeItem(hashcode);
        sessionStorage.removeItem(`${hashcode}:timestamp`);
    }

    return fetch(url, newOptions)
        .then(response => {
            let contentType = response.headers.get('Content-Type') || "";
            if (contentType.indexOf("octet-stream") != -1) {

            } else {
                if (response.status == 401) {
                    const p = new Promise((reslove) => reslove({
                        error: true, retObject: {}, code: -1, msg: "验证失败"
                    }));
                    return p;
                } else {
                    let jsonRet = response.json();
                    jsonRet.then(j => {
                        if (j.retCode == -1 && j.retObject == "请重新登陆！") {
                            //message.info(j.retCode + "  " + j.retObject);
                        }
                    });
                    return jsonRet;
                }
            }
        })
}